const locale = {
  APOLLO_ERROR_TITLE: 'Algo salió mal con el servidor',
  APOLLO_ERROR_DESCRIPTION: 'Por favor, inténtelo de nuevo más tarde',
  CLOSE_NOTIFICATION_ARIA_LABEL: 'Cerrar notificación',
};

export default locale;
